export default function FinalPoints({ size = 'small', text }) {
  const baseClasses = 'mt-2 font-bold';
  const variants = {
    big: 'text-green text-2xl',
    small: 'text-yellow text-xl',
  };

  return <h3 className={`${baseClasses} ${variants[size]}`}>{text}</h3>;
}
